import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pagination-bar',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './pagination-bar.component.html',
  styleUrl: './pagination-bar.component.scss'
})
export class PaginationBarComponent {
selectedPageNumber:any;

  @Input()
  odin: boolean = true;

  @Input()
  currentPage: number = 0;

  @Input()
  from: number = 0;

  @Input()
  to: number = 0;

  @Input()
  totalElement: number = 0;

  @Input()
  totalPages: number = 0;

  @Input()
  pageSize: number = 0;

  @Input()
  firstPage: boolean = false;

  @Input()
  lastPage: boolean = false;

  @Input()
  totalElements: number = 0;

  @Output()
  startPage: EventEmitter<number> = new EventEmitter();

  @Output()
  finalPage: EventEmitter<number> = new EventEmitter();

  @Output()
  previousPage: EventEmitter<number> = new EventEmitter();

  @Output()
  nextPage: EventEmitter<number> = new EventEmitter();

  @Output()
  changePageNumber: EventEmitter<number> = new EventEmitter();

checkForChangeEvent(value:any){
  this.changePageNumber.emit(value)
}
}
